// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/admin_service.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateAdminRequestSchema, CreateAdminResponseSchema, DeleteAdminRequestSchema, GetAdminMeRequestSchema, GetAdminMeResponseSchema, ListAdminsRequestSchema, ListAdminsResponseSchema, SetAdminDeveloperRequestSchema, SetAdminDeveloperResponseSchema, SetAdminRoleRequestSchema, SetAdminRoleResponseSchema } from "./admin_pb";
import { file_api_proto_v1_admin } from "./admin_pb";
import type { CancelApprovalRequestRequestSchema, CancelApprovalRequestResponseSchema, CreateApprovalRequestRequestSchema, CreateApprovalRequestResponseSchema, DecideApprovalRequestRequestSchema, DecideApprovalRequestResponseSchema, ExecuteApprovalRequestBypassRequestSchema, ExecuteApprovalRequestBypassResponseSchema, ListAdminAuditLogsRequestSchema, ListAdminAuditLogsResponseSchema, ListApprovalRequestsRequestSchema, ListApprovalRequestsResponseSchema } from "./admin_approval_pb";
import { file_api_proto_v1_admin_approval } from "./admin_approval_pb";
import type { GetCompanyCreditRequestSchema, GetCompanyCreditResponseSchema, ListCompanyCreditLedgerEntriesRequestSchema, ListCompanyCreditLedgerEntriesResponseSchema } from "./admin_credit_pb";
import { file_api_proto_v1_admin_credit } from "./admin_credit_pb";
import type { Color, ColorManufacturer, ColorTone } from "./color_pb";
import { file_api_proto_v1_color } from "./color_pb";
import type { EmptyResponseSchema } from "./common_pb";
import { file_api_proto_v1_common } from "./common_pb";
import type { AnonymizeCompanyStaffRequestSchema, CreateCompanyRequestSchema, CreateCompanyStaffRequestSchema, CreateCompanyStaffResponseSchema, DeleteCompanyStaffRequestSchema, GetCompanyResponse, GetCompanyResponseSchema, HandoverCompanyStaffAssignmentsRequestSchema, HandoverCompanyStaffAssignmentsResponseSchema, PreviewCompanyStaffHandoverRequestSchema, PreviewCompanyStaffHandoverResponseSchema, SetCompanyStaffSupportAccessRequestSchema, SetCompanyStaffSupportAccessResponseSchema, UpdateCompanyStaffRequestSchema, UpdateCompanyStaffResponseSchema } from "./company_pb";
import { file_api_proto_v1_company } from "./company_pb";
import type { CreateCompanyConstructionTypeRequestSchema, CreateCompanyConstructionTypeResponseSchema, DeleteCompanyConstructionTypeRequestSchema, DeleteCompanyConstructionTypeResponseSchema, GetCompanyConstructionTypeListRequestSchema, GetCompanyConstructionTypeListResponseSchema, GetCompanyConstructionTypeRequestSchema, GetCompanyConstructionTypeResponseSchema, UpdateCompanyConstructionTypeRequestSchema, UpdateCompanyConstructionTypeResponseSchema } from "./company_construction_types_pb";
import { file_api_proto_v1_company_construction_types } from "./company_construction_types_pb";
import type { CancelCompanyContractRequestSchema, ChangeCompanyContractPlanRequestSchema, CreateCompanyContractRequestSchema, ListCompanyContractsRequestSchema, ListCompanyContractsResponseSchema, ListServicePlansRequestSchema, ListServicePlansResponseSchema, PreviewCompanyContractPlanChangeResponseSchema, ResumeCompanyRequestSchema, ScheduleCompanyContractCancellationRequestSchema, SuspendCompanyRequestSchema, UnscheduleCompanyContractCancellationRequestSchema, UpdateCompanyContractGrantCreditsRequestSchema, UpdateCompanyContractStaffLimitRequestSchema } from "./company_contract_pb";
import { file_api_proto_v1_company_contract } from "./company_contract_pb";
import type { DeleteCompanyPermissionOverrideRequestSchema, DeleteCompanyPermissionOverrideResponseSchema, ListCompanyPermissionOverridesRequestSchema, ListCompanyPermissionOverridesResponseSchema, SetCompanyPermissionOverrideRequestSchema, SetCompanyPermissionOverrideResponseSchema } from "./company_permission_override_pb";
import { file_api_proto_v1_company_permission_override } from "./company_permission_override_pb";
import type { CreateConstructionTypeRequestSchema, CreateConstructionTypeResponseSchema, DeleteConstructionTypeRequestSchema, DeleteConstructionTypeResponseSchema, GetConstructionTypeListRequestSchema, GetConstructionTypeListResponseSchema, GetConstructionTypeRequestSchema, GetConstructionTypeResponseSchema, UpdateConstructionTypeRequestSchema, UpdateConstructionTypeResponseSchema } from "./construction_types_pb";
import { file_api_proto_v1_construction_types } from "./construction_types_pb";
import type { GetCreditLedgerSettingsRequestSchema, GetCreditLedgerSettingsResponseSchema, UpdateCreditLedgerSettingsRequestSchema, UpdateCreditLedgerSettingsResponseSchema } from "./credit_ledger_settings_pb";
import { file_api_proto_v1_credit_ledger_settings } from "./credit_ledger_settings_pb";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { ImageResponse } from "./image_pb";
import { file_api_proto_v1_image } from "./image_pb";
import type { BulkResolveKnowledgeReviewFlagsRequestSchema, BulkResolveKnowledgeReviewFlagsResponseSchema, CreateKnowledgeChapterRequestSchema, CreateKnowledgeChapterResponseSchema, CreateKnowledgeDocumentRequestSchema, CreateKnowledgeDocumentResponseSchema, CreateKnowledgeReviewFlagsRequestSchema, CreateKnowledgeReviewFlagsResponseSchema, CreateKnowledgeSectionRequestSchema, CreateKnowledgeSectionResponseSchema, ExportKnowledgeMarkdownRequestSchema, ExportKnowledgeMarkdownResponseSchema, GetKnowledgeDocumentRequestSchema, GetKnowledgeDocumentResponseSchema, GetKnowledgeReviewDashboardRequestSchema, GetKnowledgeReviewDashboardResponseSchema, GetKnowledgeSectionRequestSchema, GetKnowledgeSectionResponseSchema, ListKnowledgeDocumentsRequestSchema, ListKnowledgeDocumentsResponseSchema, ListKnowledgeReviewFlagsRequestSchema, ListKnowledgeReviewFlagsResponseSchema, ListKnowledgeSectionRevisionsRequestSchema, ListKnowledgeSectionRevisionsResponseSchema, ListKnowledgeSectionsForReviewRequestSchema, ListKnowledgeSectionsForReviewResponseSchema, ReorderKnowledgeSectionsRequestSchema, ReorderKnowledgeSectionsResponseSchema, ResolveKnowledgeReviewFlagRequestSchema, ResolveKnowledgeReviewFlagResponseSchema, RevertKnowledgeSectionRequestSchema, RevertKnowledgeSectionResponseSchema, SearchKnowledgePreviewRequestSchema, SearchKnowledgePreviewResponseSchema, SupersedeKnowledgeSectionRequestSchema, SupersedeKnowledgeSectionResponseSchema, UpdateKnowledgeDocumentRequestSchema, UpdateKnowledgeDocumentResponseSchema, UpdateKnowledgeReviewFlagNoteRequestSchema, UpdateKnowledgeReviewFlagNoteResponseSchema, UpdateKnowledgeSectionRequestSchema, UpdateKnowledgeSectionResponseSchema } from "./knowledge_pb";
import { file_api_proto_v1_knowledge } from "./knowledge_pb";
import type { CreateMaterialRequestSchema, CreateMaterialResponseSchema, DeleteMaterialRequestSchema, DeleteMaterialResponseSchema, ListMaterialManufacturersRequestSchema, ListMaterialManufacturersResponseSchema, ListMaterialsRequestSchema, ListMaterialsResponseSchema, UpdateMaterialRequestSchema, UpdateMaterialResponseSchema } from "./material_pb";
import { file_api_proto_v1_material } from "./material_pb";
import type { ClearMediaRooferReviewsRequestSchema, ClearMediaRooferReviewsResponseSchema, CreateMediaImageUploadRequestSchema, CreateMediaImageUploadResponseSchema, CreateMediaPreviewTokenRequestSchema, CreateMediaPreviewTokenResponseSchema, CreateMediaRooferFieldsRequestSchema, CreateMediaRooferFieldsResponseSchema, DeleteMediaArticleRequestSchema, DeleteMediaArticleResponseSchema, DeleteMediaAuthorRequestSchema, DeleteMediaAuthorResponseSchema, DeleteMediaCategoryRequestSchema, DeleteMediaCategoryResponseSchema, DeleteMediaCredentialItemRequestSchema, DeleteMediaCredentialItemResponseSchema, DeleteMediaImageRequestSchema, DeleteMediaImageResponseSchema, DeleteMediaInterviewRequestSchema, DeleteMediaInterviewResponseSchema, DeleteMediaRooferRequestSchema, DeleteMediaRooferResponseSchema, DeleteMediaTagRequestSchema, DeleteMediaTagResponseSchema, FetchMediaRooferReviewsRequestSchema, FetchMediaRooferReviewsResponseSchema, FetchMediaRooferUsageMetricsRequestSchema, FetchMediaRooferUsageMetricsResponseSchema, FetchMediaUrlMetadataRequestSchema, FetchMediaUrlMetadataResponseSchema, FinalizeMediaImageUploadRequestSchema, FinalizeMediaImageUploadResponseSchema, GetMediaArticleRequestSchema, GetMediaArticleResponseSchema, GetMediaAuthorRequestSchema, GetMediaAuthorResponseSchema, GetMediaImageRequestSchema, GetMediaImageResponseSchema, GetMediaInterviewRequestSchema, GetMediaInterviewResponseSchema, GetMediaRooferRequestSchema, GetMediaRooferResponseSchema, ImportMediaImageFromUrlRequestSchema, ImportMediaImageFromUrlResponseSchema, ListMediaArticlesRequestSchema, ListMediaArticlesResponseSchema, ListMediaAuthorsRequestSchema, ListMediaAuthorsResponseSchema, ListMediaCategoriesRequestSchema, ListMediaCategoriesResponseSchema, ListMediaContactSubmissionsRequestSchema, ListMediaContactSubmissionsResponseSchema, ListMediaCredentialItemsRequestSchema, ListMediaCredentialItemsResponseSchema, ListMediaFeaturedItemsRequestSchema, ListMediaFeaturedItemsResponseSchema, ListMediaImagesRequestSchema, ListMediaImagesResponseSchema, ListMediaInterviewsRequestSchema, ListMediaInterviewsResponseSchema, ListMediaRoofersRequestSchema, ListMediaRoofersResponseSchema, ListMediaTagsRequestSchema, ListMediaTagsResponseSchema, PublishMediaArticleRequestSchema, PublishMediaArticleResponseSchema, SaveMediaArticleDraftRequestSchema, SaveMediaArticleDraftResponseSchema, SetMediaFeaturedItemsRequestSchema, SetMediaFeaturedItemsResponseSchema, UpdateMediaContactSubmissionHandledRequestSchema, UpdateMediaContactSubmissionHandledResponseSchema, UpdateMediaImageNameRequestSchema, UpdateMediaImageNameResponseSchema, UpdateMediaRooferAiUsageVisibilityRequestSchema, UpdateMediaRooferAiUsageVisibilityResponseSchema, UpdateMediaRooferChildrenRequestSchema, UpdateMediaRooferChildrenResponseSchema, UpdateMediaRooferFieldsRequestSchema, UpdateMediaRooferFieldsResponseSchema, UpdateMediaRooferListedRequestSchema, UpdateMediaRooferListedResponseSchema, UpdateMediaRooferPublishedRequestSchema, UpdateMediaRooferPublishedResponseSchema, UpdateMediaRooferUsageMetricsVisibilityRequestSchema, UpdateMediaRooferUsageMetricsVisibilityResponseSchema, UploadMediaImageRequestSchema, UploadMediaImageResponseSchema, UpsertMediaAuthorRequestSchema, UpsertMediaAuthorResponseSchema, UpsertMediaCategoryRequestSchema, UpsertMediaCategoryResponseSchema, UpsertMediaCredentialItemRequestSchema, UpsertMediaCredentialItemResponseSchema, UpsertMediaInterviewRequestSchema, UpsertMediaInterviewResponseSchema, UpsertMediaRooferRequestSchema, UpsertMediaRooferResponseSchema, UpsertMediaTagRequestSchema, UpsertMediaTagResponseSchema } from "./media_cms_pb";
import { file_api_proto_v1_media_cms } from "./media_cms_pb";
import type { ListCompanyStaffPermissionsRequestSchema, ListCompanyStaffPermissionsResponseSchema, ListPermissionCodesRequestSchema, ListPermissionCodesResponseSchema, UpdateCompanyStaffPermissionsRequestSchema } from "./staff_permission_pb";
import { file_api_proto_v1_staff_permission } from "./staff_permission_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/admin_service.proto.
 */
export const file_api_proto_v1_admin_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_admin, file_api_proto_v1_admin_approval, file_api_proto_v1_admin_credit, file_api_proto_v1_color, file_api_proto_v1_common, file_api_proto_v1_company, file_api_proto_v1_company_construction_types, file_api_proto_v1_company_contract, file_api_proto_v1_company_permission_override, file_api_proto_v1_construction_types, file_api_proto_v1_credit_ledger_settings, file_api_proto_v1_file, file_api_proto_v1_image, file_api_proto_v1_knowledge, file_api_proto_v1_material, file_api_proto_v1_media_cms, file_api_proto_v1_staff_permission, file_google_protobuf_wrappers]);

/**
 * AdminService specific messages
 *
 * @generated from message api_proto.v1.GetCompanyListRequest
 */
export type GetCompanyListRequest = Message<"api_proto.v1.GetCompanyListRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetCompanyListRequest.
 * Use `create(GetCompanyListRequestSchema)` to create a new message.
 */
export const GetCompanyListRequestSchema: GenMessage<GetCompanyListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 0);

/**
 * @generated from message api_proto.v1.GetCompanyListResponse
 */
export type GetCompanyListResponse = Message<"api_proto.v1.GetCompanyListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.GetCompanyResponse companies = 1;
   */
  companies: GetCompanyResponse[];
};

/**
 * Describes the message api_proto.v1.GetCompanyListResponse.
 * Use `create(GetCompanyListResponseSchema)` to create a new message.
 */
export const GetCompanyListResponseSchema: GenMessage<GetCompanyListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 1);

/**
 * @generated from message api_proto.v1.GetCompanyDetailRequest
 */
export type GetCompanyDetailRequest = Message<"api_proto.v1.GetCompanyDetailRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCompanyDetailRequest.
 * Use `create(GetCompanyDetailRequestSchema)` to create a new message.
 */
export const GetCompanyDetailRequestSchema: GenMessage<GetCompanyDetailRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 2);

/**
 * @generated from message api_proto.v1.IssueCompanyStaffPasswordLinkRequest
 */
export type IssueCompanyStaffPasswordLinkRequest = Message<"api_proto.v1.IssueCompanyStaffPasswordLinkRequest"> & {
  /**
   * @generated from field: int64 staff_id = 1;
   */
  staffId: bigint;
};

/**
 * Describes the message api_proto.v1.IssueCompanyStaffPasswordLinkRequest.
 * Use `create(IssueCompanyStaffPasswordLinkRequestSchema)` to create a new message.
 */
export const IssueCompanyStaffPasswordLinkRequestSchema: GenMessage<IssueCompanyStaffPasswordLinkRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 3);

/**
 * @generated from message api_proto.v1.IssueCompanyStaffPasswordLinkResponse
 */
export type IssueCompanyStaffPasswordLinkResponse = Message<"api_proto.v1.IssueCompanyStaffPasswordLinkResponse"> & {
};

/**
 * Describes the message api_proto.v1.IssueCompanyStaffPasswordLinkResponse.
 * Use `create(IssueCompanyStaffPasswordLinkResponseSchema)` to create a new message.
 */
export const IssueCompanyStaffPasswordLinkResponseSchema: GenMessage<IssueCompanyStaffPasswordLinkResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 4);

/**
 * @generated from message api_proto.v1.UploadCustomerCsvResponse
 */
export type UploadCustomerCsvResponse = Message<"api_proto.v1.UploadCustomerCsvResponse"> & {
  /**
   * @generated from field: bool result = 1;
   */
  result: boolean;
};

/**
 * Describes the message api_proto.v1.UploadCustomerCsvResponse.
 * Use `create(UploadCustomerCsvResponseSchema)` to create a new message.
 */
export const UploadCustomerCsvResponseSchema: GenMessage<UploadCustomerCsvResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 5);

/**
 * @generated from message api_proto.v1.UploadCustomerCsvRequest
 */
export type UploadCustomerCsvRequest = Message<"api_proto.v1.UploadCustomerCsvRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.UploadCustomerCsvRequest.
 * Use `create(UploadCustomerCsvRequestSchema)` to create a new message.
 */
export const UploadCustomerCsvRequestSchema: GenMessage<UploadCustomerCsvRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 6);

/**
 * @generated from message api_proto.v1.UploadDealCsvRequest
 */
export type UploadDealCsvRequest = Message<"api_proto.v1.UploadDealCsvRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.UploadDealCsvRequest.
 * Use `create(UploadDealCsvRequestSchema)` to create a new message.
 */
export const UploadDealCsvRequestSchema: GenMessage<UploadDealCsvRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 7);

/**
 * @generated from message api_proto.v1.DealListColumn
 */
export type DealListColumn = Message<"api_proto.v1.DealListColumn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message api_proto.v1.DealListColumn.
 * Use `create(DealListColumnSchema)` to create a new message.
 */
export const DealListColumnSchema: GenMessage<DealListColumn> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 8);

/**
 * @generated from message api_proto.v1.GetDealListColumnsRequest
 */
export type GetDealListColumnsRequest = Message<"api_proto.v1.GetDealListColumnsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealListColumnsRequest.
 * Use `create(GetDealListColumnsRequestSchema)` to create a new message.
 */
export const GetDealListColumnsRequestSchema: GenMessage<GetDealListColumnsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 9);

/**
 * @generated from message api_proto.v1.GetDealListColumnsResponse
 */
export type GetDealListColumnsResponse = Message<"api_proto.v1.GetDealListColumnsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.DealListColumn visible_columns = 1;
   */
  visibleColumns: DealListColumn[];

  /**
   * @generated from field: repeated api_proto.v1.DealListColumn hidden_columns = 2;
   */
  hiddenColumns: DealListColumn[];
};

/**
 * Describes the message api_proto.v1.GetDealListColumnsResponse.
 * Use `create(GetDealListColumnsResponseSchema)` to create a new message.
 */
export const GetDealListColumnsResponseSchema: GenMessage<GetDealListColumnsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 10);

/**
 * @generated from message api_proto.v1.SaveDealListColumnsRequest
 */
export type SaveDealListColumnsRequest = Message<"api_proto.v1.SaveDealListColumnsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: repeated api_proto.v1.DealListColumn columns = 2;
   */
  columns: DealListColumn[];
};

/**
 * Describes the message api_proto.v1.SaveDealListColumnsRequest.
 * Use `create(SaveDealListColumnsRequestSchema)` to create a new message.
 */
export const SaveDealListColumnsRequestSchema: GenMessage<SaveDealListColumnsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 11);

/**
 * @generated from message api_proto.v1.SaveDealListColumnsResponse
 */
export type SaveDealListColumnsResponse = Message<"api_proto.v1.SaveDealListColumnsResponse"> & {
};

/**
 * Describes the message api_proto.v1.SaveDealListColumnsResponse.
 * Use `create(SaveDealListColumnsResponseSchema)` to create a new message.
 */
export const SaveDealListColumnsResponseSchema: GenMessage<SaveDealListColumnsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 12);

/**
 * 色マスター管理
 *
 * @generated from message api_proto.v1.ListColorManufacturersRequest
 */
export type ListColorManufacturersRequest = Message<"api_proto.v1.ListColorManufacturersRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListColorManufacturersRequest.
 * Use `create(ListColorManufacturersRequestSchema)` to create a new message.
 */
export const ListColorManufacturersRequestSchema: GenMessage<ListColorManufacturersRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 13);

/**
 * @generated from message api_proto.v1.ListColorManufacturersResponse
 */
export type ListColorManufacturersResponse = Message<"api_proto.v1.ListColorManufacturersResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.ColorManufacturer manufacturers = 2;
   */
  manufacturers: ColorManufacturer[];
};

/**
 * Describes the message api_proto.v1.ListColorManufacturersResponse.
 * Use `create(ListColorManufacturersResponseSchema)` to create a new message.
 */
export const ListColorManufacturersResponseSchema: GenMessage<ListColorManufacturersResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 14);

/**
 * @generated from message api_proto.v1.ListColorsRequest
 */
export type ListColorsRequest = Message<"api_proto.v1.ListColorsRequest"> & {
  /**
   * 色コード・色名の部分一致
   *
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * 取得件数（デフォルト50）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * オフセット
   *
   * @generated from field: int32 offset = 5;
   */
  offset: number;

  /**
   * メーカーID絞り込み（0なら全メーカー）
   *
   * @generated from field: int64 manufacturer_id = 6;
   */
  manufacturerId: bigint;

  /**
   * トーン絞り込み（COLOR_TONE_UNSPECIFIED なら全トーン）
   *
   * @generated from field: api_proto.v1.ColorTone tone = 7;
   */
  tone: ColorTone;
};

/**
 * Describes the message api_proto.v1.ListColorsRequest.
 * Use `create(ListColorsRequestSchema)` to create a new message.
 */
export const ListColorsRequestSchema: GenMessage<ListColorsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 15);

/**
 * @generated from message api_proto.v1.ListColorsResponse
 */
export type ListColorsResponse = Message<"api_proto.v1.ListColorsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Color colors = 1;
   */
  colors: Color[];

  /**
   * フィルタ条件に合致する全件数
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListColorsResponse.
 * Use `create(ListColorsResponseSchema)` to create a new message.
 */
export const ListColorsResponseSchema: GenMessage<ListColorsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 16);

/**
 * @generated from message api_proto.v1.CreateColorRequest
 */
export type CreateColorRequest = Message<"api_proto.v1.CreateColorRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string hex = 3;
   */
  hex: string;

  /**
   * @generated from field: int32 r = 4;
   */
  r: number;

  /**
   * @generated from field: int32 g = 5;
   */
  g: number;

  /**
   * @generated from field: int32 b = 6;
   */
  b: number;

  /**
   * @generated from field: string manufacturer = 7;
   */
  manufacturer: string;

  /**
   * 必須（COLOR_TONE_UNSPECIFIED は InvalidArgument）
   *
   * @generated from field: api_proto.v1.ColorTone tone = 10;
   */
  tone: ColorTone;
};

/**
 * Describes the message api_proto.v1.CreateColorRequest.
 * Use `create(CreateColorRequestSchema)` to create a new message.
 */
export const CreateColorRequestSchema: GenMessage<CreateColorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 17);

/**
 * @generated from message api_proto.v1.CreateColorResponse
 */
export type CreateColorResponse = Message<"api_proto.v1.CreateColorResponse"> & {
  /**
   * @generated from field: api_proto.v1.Color color = 1;
   */
  color?: Color;
};

/**
 * Describes the message api_proto.v1.CreateColorResponse.
 * Use `create(CreateColorResponseSchema)` to create a new message.
 */
export const CreateColorResponseSchema: GenMessage<CreateColorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 18);

/**
 * @generated from message api_proto.v1.UpdateColorRequest
 */
export type UpdateColorRequest = Message<"api_proto.v1.UpdateColorRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string hex = 4;
   */
  hex: string;

  /**
   * @generated from field: int32 r = 5;
   */
  r: number;

  /**
   * @generated from field: int32 g = 6;
   */
  g: number;

  /**
   * @generated from field: int32 b = 7;
   */
  b: number;

  /**
   * @generated from field: string manufacturer = 8;
   */
  manufacturer: string;

  /**
   * 必須（COLOR_TONE_UNSPECIFIED は InvalidArgument）
   *
   * @generated from field: api_proto.v1.ColorTone tone = 11;
   */
  tone: ColorTone;
};

/**
 * Describes the message api_proto.v1.UpdateColorRequest.
 * Use `create(UpdateColorRequestSchema)` to create a new message.
 */
export const UpdateColorRequestSchema: GenMessage<UpdateColorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 19);

/**
 * @generated from message api_proto.v1.UpdateColorResponse
 */
export type UpdateColorResponse = Message<"api_proto.v1.UpdateColorResponse"> & {
  /**
   * @generated from field: api_proto.v1.Color color = 1;
   */
  color?: Color;
};

/**
 * Describes the message api_proto.v1.UpdateColorResponse.
 * Use `create(UpdateColorResponseSchema)` to create a new message.
 */
export const UpdateColorResponseSchema: GenMessage<UpdateColorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 20);

/**
 * @generated from message api_proto.v1.DeleteColorRequest
 */
export type DeleteColorRequest = Message<"api_proto.v1.DeleteColorRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteColorRequest.
 * Use `create(DeleteColorRequestSchema)` to create a new message.
 */
export const DeleteColorRequestSchema: GenMessage<DeleteColorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 21);

/**
 * @generated from message api_proto.v1.DeleteColorResponse
 */
export type DeleteColorResponse = Message<"api_proto.v1.DeleteColorResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteColorResponse.
 * Use `create(DeleteColorResponseSchema)` to create a new message.
 */
export const DeleteColorResponseSchema: GenMessage<DeleteColorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 22);

/**
 * @generated from message api_proto.v1.UploadColorCsvRequest
 */
export type UploadColorCsvRequest = Message<"api_proto.v1.UploadColorCsvRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadColorCsvRequest.
 * Use `create(UploadColorCsvRequestSchema)` to create a new message.
 */
export const UploadColorCsvRequestSchema: GenMessage<UploadColorCsvRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 23);

/**
 * @generated from message api_proto.v1.UploadColorCsvResponse
 */
export type UploadColorCsvResponse = Message<"api_proto.v1.UploadColorCsvResponse"> & {
  /**
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * @generated from field: int32 updated_count = 2;
   */
  updatedCount: number;
};

/**
 * Describes the message api_proto.v1.UploadColorCsvResponse.
 * Use `create(UploadColorCsvResponseSchema)` to create a new message.
 */
export const UploadColorCsvResponseSchema: GenMessage<UploadColorCsvResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 24);

/**
 * AIカラープロジェクトのサマリー（削除前の確認表示用）を取得するリクエスト。
 *
 * @generated from message api_proto.v1.GetAiColorProjectSummaryRequest
 */
export type GetAiColorProjectSummaryRequest = Message<"api_proto.v1.GetAiColorProjectSummaryRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message api_proto.v1.GetAiColorProjectSummaryRequest.
 * Use `create(GetAiColorProjectSummaryRequestSchema)` to create a new message.
 */
export const GetAiColorProjectSummaryRequestSchema: GenMessage<GetAiColorProjectSummaryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 25);

/**
 * @generated from message api_proto.v1.GetAiColorProjectSummaryResponse
 */
export type GetAiColorProjectSummaryResponse = Message<"api_proto.v1.GetAiColorProjectSummaryResponse"> & {
  /**
   * @generated from field: string company_name = 1;
   */
  companyName: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * 顧客未設定なら空
   *
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * 案件連携が無ければ空
   *
   * @generated from field: string deal_name = 4;
   */
  dealName: string;

  /**
   * @generated from field: int32 image_count = 5;
   */
  imageCount: number;
};

/**
 * Describes the message api_proto.v1.GetAiColorProjectSummaryResponse.
 * Use `create(GetAiColorProjectSummaryResponseSchema)` to create a new message.
 */
export const GetAiColorProjectSummaryResponseSchema: GenMessage<GetAiColorProjectSummaryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 26);

/**
 * AIカラープロジェクト（プロジェクト・画像・共有リンク）を論理削除するリクエスト。
 *
 * @generated from message api_proto.v1.DeleteAiColorProjectRequest
 */
export type DeleteAiColorProjectRequest = Message<"api_proto.v1.DeleteAiColorProjectRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message api_proto.v1.DeleteAiColorProjectRequest.
 * Use `create(DeleteAiColorProjectRequestSchema)` to create a new message.
 */
export const DeleteAiColorProjectRequestSchema: GenMessage<DeleteAiColorProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 27);

/**
 * @generated from message api_proto.v1.DeleteAiColorProjectResponse
 */
export type DeleteAiColorProjectResponse = Message<"api_proto.v1.DeleteAiColorProjectResponse"> & {
  /**
   * @generated from field: int32 deleted_image_count = 1;
   */
  deletedImageCount: number;

  /**
   * @generated from field: int32 deleted_share_link_count = 2;
   */
  deletedShareLinkCount: number;
};

/**
 * Describes the message api_proto.v1.DeleteAiColorProjectResponse.
 * Use `create(DeleteAiColorProjectResponseSchema)` to create a new message.
 */
export const DeleteAiColorProjectResponseSchema: GenMessage<DeleteAiColorProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 28);

/**
 * @generated from message api_proto.v1.UploadMaterialXlsxRequest
 */
export type UploadMaterialXlsxRequest = Message<"api_proto.v1.UploadMaterialXlsxRequest"> & {
  /**
   * @generated from field: api_proto.v1.Upload file = 1;
   */
  file?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadMaterialXlsxRequest.
 * Use `create(UploadMaterialXlsxRequestSchema)` to create a new message.
 */
export const UploadMaterialXlsxRequestSchema: GenMessage<UploadMaterialXlsxRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 29);

/**
 * @generated from message api_proto.v1.UploadMaterialXlsxResponse
 */
export type UploadMaterialXlsxResponse = Message<"api_proto.v1.UploadMaterialXlsxResponse"> & {
  /**
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * @generated from field: int32 updated_count = 2;
   */
  updatedCount: number;

  /**
   * 画像欠落などで処理をスキップした行数
   *
   * @generated from field: int32 skipped_count = 3;
   */
  skippedCount: number;
};

/**
 * Describes the message api_proto.v1.UploadMaterialXlsxResponse.
 * Use `create(UploadMaterialXlsxResponseSchema)` to create a new message.
 */
export const UploadMaterialXlsxResponseSchema: GenMessage<UploadMaterialXlsxResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 30);

/**
 * 企業のロゴ・社印画像を対象企業向けにアップロードする
 *
 * @generated from message api_proto.v1.UploadCompanyImageRequest
 */
export type UploadCompanyImageRequest = Message<"api_proto.v1.UploadCompanyImageRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: api_proto.v1.Upload image = 2;
   */
  image?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadCompanyImageRequest.
 * Use `create(UploadCompanyImageRequestSchema)` to create a new message.
 */
export const UploadCompanyImageRequestSchema: GenMessage<UploadCompanyImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 31);

/**
 * @generated from message api_proto.v1.UploadCompanyImageResponse
 */
export type UploadCompanyImageResponse = Message<"api_proto.v1.UploadCompanyImageResponse"> & {
  /**
   * アップロード済み画像（id + url）
   *
   * @generated from field: api_proto.v1.ImageResponse image = 1;
   */
  image?: ImageResponse;
};

/**
 * Describes the message api_proto.v1.UploadCompanyImageResponse.
 * Use `create(UploadCompanyImageResponseSchema)` to create a new message.
 */
export const UploadCompanyImageResponseSchema: GenMessage<UploadCompanyImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 32);

/**
 * 企業のロゴ・社印を設定する（未指定のフィールドはNULL=未設定に戻す）
 *
 * @generated from message api_proto.v1.UpdateCompanyImagesRequest
 */
export type UpdateCompanyImagesRequest = Message<"api_proto.v1.UpdateCompanyImagesRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * 未指定(null)=ロゴをクリア
   *
   * @generated from field: google.protobuf.Int64Value logo_id = 2;
   */
  logoId?: bigint;

  /**
   * 未指定(null)=社印をクリア
   *
   * @generated from field: google.protobuf.Int64Value seal_id = 3;
   */
  sealId?: bigint;
};

/**
 * Describes the message api_proto.v1.UpdateCompanyImagesRequest.
 * Use `create(UpdateCompanyImagesRequestSchema)` to create a new message.
 */
export const UpdateCompanyImagesRequestSchema: GenMessage<UpdateCompanyImagesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 33);

/**
 * ListCompanyDealAreas: 企業の全案件の現場住所から distinct な（都道府県, 市区町村）を返す
 * （メディア認定店の工事対応エリア取り込み候補用）
 *
 * @generated from message api_proto.v1.ListCompanyDealAreasRequest
 */
export type ListCompanyDealAreasRequest = Message<"api_proto.v1.ListCompanyDealAreasRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.ListCompanyDealAreasRequest.
 * Use `create(ListCompanyDealAreasRequestSchema)` to create a new message.
 */
export const ListCompanyDealAreasRequestSchema: GenMessage<ListCompanyDealAreasRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 34);

/**
 * @generated from message api_proto.v1.CompanyDealArea
 */
export type CompanyDealArea = Message<"api_proto.v1.CompanyDealArea"> & {
  /**
   * 都道府県ラベル（例 "東京都"。JIS コードから変換済み）
   *
   * @generated from field: string prefecture = 1;
   */
  prefecture: string;

  /**
   * 市区町村（自由テキスト、空の場合あり）
   *
   * @generated from field: string city = 2;
   */
  city: string;
};

/**
 * Describes the message api_proto.v1.CompanyDealArea.
 * Use `create(CompanyDealAreaSchema)` to create a new message.
 */
export const CompanyDealAreaSchema: GenMessage<CompanyDealArea> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 35);

/**
 * @generated from message api_proto.v1.ListCompanyDealAreasResponse
 */
export type ListCompanyDealAreasResponse = Message<"api_proto.v1.ListCompanyDealAreasResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyDealArea areas = 1;
   */
  areas: CompanyDealArea[];
};

/**
 * Describes the message api_proto.v1.ListCompanyDealAreasResponse.
 * Use `create(ListCompanyDealAreasResponseSchema)` to create a new message.
 */
export const ListCompanyDealAreasResponseSchema: GenMessage<ListCompanyDealAreasResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_service, 36);

/**
 * @generated from service api_proto.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc api_proto.v1.AdminService.GetAdminMe
   */
  getAdminMe: {
    methodKind: "unary";
    input: typeof GetAdminMeRequestSchema;
    output: typeof GetAdminMeResponseSchema;
  },
  /**
   * 管理者管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListAdmins
   */
  listAdmins: {
    methodKind: "unary";
    input: typeof ListAdminsRequestSchema;
    output: typeof ListAdminsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.CreateAdmin
   */
  createAdmin: {
    methodKind: "unary";
    input: typeof CreateAdminRequestSchema;
    output: typeof CreateAdminResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteAdmin
   */
  deleteAdmin: {
    methodKind: "unary";
    input: typeof DeleteAdminRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 管理者ロールの変更（plan-restructure-2026-10 R6 tasks 6.4b）。ceo のみ。自分自身の降格は不可
   *
   * @generated from rpc api_proto.v1.AdminService.SetAdminRole
   */
  setAdminRole: {
    methodKind: "unary";
    input: typeof SetAdminRoleRequestSchema;
    output: typeof SetAdminRoleResponseSchema;
  },
  /**
   * 管理者の開発者フラグの変更（admin-ia-redesign-2026-09 §5.2）。ceoのみ。自分自身は変更不可。
   * 開発者フラグはFeature Flag系RPCのゲートに使う（承認ロールとは独立）
   *
   * @generated from rpc api_proto.v1.AdminService.SetAdminDeveloper
   */
  setAdminDeveloper: {
    methodKind: "unary";
    input: typeof SetAdminDeveloperRequestSchema;
    output: typeof SetAdminDeveloperResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.CreateCompany
   */
  createCompany: {
    methodKind: "unary";
    input: typeof CreateCompanyRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.CreateCompanyStaff
   */
  createCompanyStaff: {
    methodKind: "unary";
    input: typeof CreateCompanyStaffRequestSchema;
    output: typeof CreateCompanyStaffResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyStaff
   */
  updateCompanyStaff: {
    methodKind: "unary";
    input: typeof UpdateCompanyStaffRequestSchema;
    output: typeof UpdateCompanyStaffResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.ArchiveCompanyStaff
   */
  archiveCompanyStaff: {
    methodKind: "unary";
    input: typeof DeleteCompanyStaffRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * スタッフの停止（アーカイブ）を解除して有効に戻す。停止は可逆な状態（decisions.md決定90(c)）。
   * 所属に業務管理（crm）が含まれ、かつアカウント上限に達している場合は拒否する（決定90(i)）
   *
   * @generated from rpc api_proto.v1.AdminService.UnarchiveCompanyStaff
   */
  unarchiveCompanyStaff: {
    methodKind: "unary";
    input: typeof DeleteCompanyStaffRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * スタッフの退職処理（開発者限定・停止済みが前提。openspec/changes/archive/2026-10-09-admin-staff-offboarding）。
   * 引き継ぎの対象件数を副作用なしで返す
   *
   * @generated from rpc api_proto.v1.AdminService.PreviewCompanyStaffHandover
   */
  previewCompanyStaffHandover: {
    methodKind: "unary";
    input: typeof PreviewCompanyStaffHandoverRequestSchema;
    output: typeof PreviewCompanyStaffHandoverResponseSchema;
  },
  /**
   * 停止済みスタッフの担当（案件・顧客・見積書・請求書・追加契約）を同じ企業の有効なスタッフへ一括で付け替える
   *
   * @generated from rpc api_proto.v1.AdminService.HandoverCompanyStaffAssignments
   */
  handoverCompanyStaffAssignments: {
    methodKind: "unary";
    input: typeof HandoverCompanyStaffAssignmentsRequestSchema;
    output: typeof HandoverCompanyStaffAssignmentsResponseSchema;
  },
  /**
   * 停止済みスタッフの氏名・メール・LINE連携を匿名化し、Firebaseユーザーを削除する（不可逆）
   *
   * @generated from rpc api_proto.v1.AdminService.AnonymizeCompanyStaff
   */
  anonymizeCompanyStaff: {
    methodKind: "unary";
    input: typeof AnonymizeCompanyStaffRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * ハウスケープのサポートアカウントのログインをON（期限つき）/OFFにする（決定125）。Admin全員が呼べ、承認ワークフローは通さない。
   * 監査ログ（company_staff.support_access.enable / .disable）とSlack監査通知に残す
   *
   * @generated from rpc api_proto.v1.AdminService.SetCompanyStaffSupportAccess
   */
  setCompanyStaffSupportAccess: {
    methodKind: "unary";
    input: typeof SetCompanyStaffSupportAccessRequestSchema;
    output: typeof SetCompanyStaffSupportAccessResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.GetCompanyDetail
   */
  getCompanyDetail: {
    methodKind: "unary";
    input: typeof GetCompanyDetailRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.GetCompanyList
   */
  getCompanyList: {
    methodKind: "unary";
    input: typeof GetCompanyListRequestSchema;
    output: typeof GetCompanyListResponseSchema;
  },
  /**
   * 企業の全案件の現場住所から distinct な（都道府県, 市区町村）を返す（メディア認定店エリア取り込み候補用）
   *
   * @generated from rpc api_proto.v1.AdminService.ListCompanyDealAreas
   */
  listCompanyDealAreas: {
    methodKind: "unary";
    input: typeof ListCompanyDealAreasRequestSchema;
    output: typeof ListCompanyDealAreasResponseSchema;
  },
  /**
   * パスワード設定トークンを再発行し、スタッフ本人の登録メールアドレス宛にパスワード設定メールを送信する。
   * レスポンスにパスワード設定 URL は含まない (#2432)。
   *
   * @generated from rpc api_proto.v1.AdminService.IssueCompanyStaffPasswordLink
   */
  issueCompanyStaffPasswordLink: {
    methodKind: "unary";
    input: typeof IssueCompanyStaffPasswordLinkRequestSchema;
    output: typeof IssueCompanyStaffPasswordLinkResponseSchema;
  },
  /**
   * クレジット台帳の全体設定（課金モード。決定105 / design-6.12-credit-ledger-settings.md）。
   * Feature Flag `credit_enforcement` の撤去後継。以下2本もadmins.is_developerが真のAdminだけが呼べる。
   *
   * @generated from rpc api_proto.v1.AdminService.GetCreditLedgerSettings
   */
  getCreditLedgerSettings: {
    methodKind: "unary";
    input: typeof GetCreditLedgerSettingsRequestSchema;
    output: typeof GetCreditLedgerSettingsResponseSchema;
  },
  /**
   * 課金モードの変更（reasonは空を拒否）。変更はadmin_audit_logsにも記録する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateCreditLedgerSettings
   */
  updateCreditLedgerSettings: {
    methodKind: "unary";
    input: typeof UpdateCreditLedgerSettingsRequestSchema;
    output: typeof UpdateCreditLedgerSettingsResponseSchema;
  },
  /**
   * スタッフ個別権限（plan-restructure-2026-10 R2）
   * 権限コードカタログ一覧。定義の SSOT は go/logic/permissioncode
   *
   * @generated from rpc api_proto.v1.AdminService.ListPermissionCodes
   */
  listPermissionCodes: {
    methodKind: "unary";
    input: typeof ListPermissionCodesRequestSchema;
    output: typeof ListPermissionCodesResponseSchema;
  },
  /**
   * 企業スタッフごとの権限コード付与状況一覧
   *
   * @generated from rpc api_proto.v1.AdminService.ListCompanyStaffPermissions
   */
  listCompanyStaffPermissions: {
    methodKind: "unary";
    input: typeof ListCompanyStaffPermissionsRequestSchema;
    output: typeof ListCompanyStaffPermissionsResponseSchema;
  },
  /**
   * 指定スタッフの権限コードを全置換する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyStaffPermissions
   */
  updateCompanyStaffPermissions: {
    methodKind: "unary";
    input: typeof UpdateCompanyStaffPermissionsRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 契約管理（Admin・新体系。plan-restructure-2026-10 R2 tasks 3.1）
   * プラン定義マスタ一覧。契約作成フォームの選択肢用
   *
   * @generated from rpc api_proto.v1.AdminService.ListServicePlans
   */
  listServicePlans: {
    methodKind: "unary";
    input: typeof ListServicePlansRequestSchema;
    output: typeof ListServicePlansResponseSchema;
  },
  /**
   * 企業の契約一覧。契約ごとにイベント履歴を nested で含む
   *
   * @generated from rpc api_proto.v1.AdminService.ListCompanyContracts
   */
  listCompanyContracts: {
    methodKind: "unary";
    input: typeof ListCompanyContractsRequestSchema;
    output: typeof ListCompanyContractsResponseSchema;
  },
  /**
   * 契約の新規作成
   *
   * @generated from rpc api_proto.v1.AdminService.CreateCompanyContract
   */
  createCompanyContract: {
    methodKind: "unary";
    input: typeof CreateCompanyContractRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 契約のプラン変更（同一 plan_type 内の tier / 支払いサイクル変更）
   *
   * @generated from rpc api_proto.v1.AdminService.ChangeCompanyContractPlan
   */
  changeCompanyContractPlan: {
    methodKind: "unary";
    input: typeof ChangeCompanyContractPlanRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * プラン変更の試算（変更後の実効の数量と、上書きの引き継ぎ・消失などの事実）。DBには書かない。
   * 入力はChangeCompanyContractPlanと同じで、同じ関数で数量を決める
   *
   * @generated from rpc api_proto.v1.AdminService.PreviewCompanyContractPlanChange
   */
  previewCompanyContractPlanChange: {
    methodKind: "unary";
    input: typeof ChangeCompanyContractPlanRequestSchema;
    output: typeof PreviewCompanyContractPlanChangeResponseSchema;
  },
  /**
   * 契約の即時解約（操作した瞬間に解約済みになる）
   *
   * @generated from rpc api_proto.v1.AdminService.CancelCompanyContract
   */
  cancelCompanyContract: {
    methodKind: "unary";
    input: typeof CancelCompanyContractRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 契約の解約予約（解約予定日の設定・変更。予定日まで使え、翌日の日次ジョブで解約される）
   *
   * @generated from rpc api_proto.v1.AdminService.ScheduleCompanyContractCancellation
   */
  scheduleCompanyContractCancellation: {
    methodKind: "unary";
    input: typeof ScheduleCompanyContractCancellationRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 契約の解約予約の取り消し
   *
   * @generated from rpc api_proto.v1.AdminService.UnscheduleCompanyContractCancellation
   */
  unscheduleCompanyContractCancellation: {
    methodKind: "unary";
    input: typeof UnscheduleCompanyContractCancellationRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * アカウント上限の上書き値の設定・解除（業務管理契約のみ）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyContractStaffLimit
   */
  updateCompanyContractStaffLimit: {
    methodKind: "unary";
    input: typeof UpdateCompanyContractStaffLimitRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 周期あたり付与量の設定・解除（営業支援契約のみ。enterprise-plan-2026-10）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyContractGrantCredits
   */
  updateCompanyContractGrantCredits: {
    methodKind: "unary";
    input: typeof UpdateCompanyContractGrantCreditsRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 企業単位の休止（companies.suspended_at の設定）
   *
   * @generated from rpc api_proto.v1.AdminService.SuspendCompany
   */
  suspendCompany: {
    methodKind: "unary";
    input: typeof SuspendCompanyRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 企業単位の休止解除
   *
   * @generated from rpc api_proto.v1.AdminService.ResumeCompany
   */
  resumeCompany: {
    methodKind: "unary";
    input: typeof ResumeCompanyRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 企業単位の権限上書き（plan-restructure-2026-10 R7 design-8.1-r7-removal.md §5）。
   * 旧権限UI撤去後の最小の編集手段。承認WFは通さず監査ログ・Slack通知のみ
   *
   * @generated from rpc api_proto.v1.AdminService.ListCompanyPermissionOverrides
   */
  listCompanyPermissionOverrides: {
    methodKind: "unary";
    input: typeof ListCompanyPermissionOverridesRequestSchema;
    output: typeof ListCompanyPermissionOverridesResponseSchema;
  },
  /**
   * 作成・更新（permission_code単位の全置換）。access_levelはnone / fullのみ（readonlyは拒否）
   *
   * @generated from rpc api_proto.v1.AdminService.SetCompanyPermissionOverride
   */
  setCompanyPermissionOverride: {
    methodKind: "unary";
    input: typeof SetCompanyPermissionOverrideRequestSchema;
    output: typeof SetCompanyPermissionOverrideResponseSchema;
  },
  /**
   * 解除（契約・プラン権限の既定へ戻す）
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteCompanyPermissionOverride
   */
  deleteCompanyPermissionOverride: {
    methodKind: "unary";
    input: typeof DeleteCompanyPermissionOverrideRequestSchema;
    output: typeof DeleteCompanyPermissionOverrideResponseSchema;
  },
  /**
   * クレジット台帳の参照（plan-restructure-2026-10 R6 tasks 5.9）
   * 残高・付与ロット・失効予定。書き込みは承認 WF 経由のみ（マイナス許容は決定101で廃止）
   *
   * @generated from rpc api_proto.v1.AdminService.GetCompanyCredit
   */
  getCompanyCredit: {
    methodKind: "unary";
    input: typeof GetCompanyCreditRequestSchema;
    output: typeof GetCompanyCreditResponseSchema;
  },
  /**
   * 企業ごとのクレジット利用履歴（付与・消費・失効・返還。企業画面の利用履歴と同じ導出）
   *
   * @generated from rpc api_proto.v1.AdminService.ListCompanyCreditLedgerEntries
   */
  listCompanyCreditLedgerEntries: {
    methodKind: "unary";
    input: typeof ListCompanyCreditLedgerEntriesRequestSchema;
    output: typeof ListCompanyCreditLedgerEntriesResponseSchema;
  },
  /**
   * 承認ワークフロー（plan-restructure-2026-10 R6 tasks 6.4）
   * 設計 SSOT: doc/architecture/db/admin-approval-audit.md
   * 承認対象操作の申請。ロールに関わらず全 Admin が行える
   *
   * @generated from rpc api_proto.v1.AdminService.CreateApprovalRequest
   */
  createApprovalRequest: {
    methodKind: "unary";
    input: typeof CreateApprovalRequestRequestSchema;
    output: typeof CreateApprovalRequestResponseSchema;
  },
  /**
   * 申請一覧（状態・企業で絞り込み）
   *
   * @generated from rpc api_proto.v1.AdminService.ListApprovalRequests
   */
  listApprovalRequests: {
    methodKind: "unary";
    input: typeof ListApprovalRequestsRequestSchema;
    output: typeof ListApprovalRequestsResponseSchema;
  },
  /**
   * 承認 / 却下。approver / ceo のみ。自分の申請は不可（相互牽制）。承認は payload 実行まで進む
   *
   * @generated from rpc api_proto.v1.AdminService.DecideApprovalRequest
   */
  decideApprovalRequest: {
    methodKind: "unary";
    input: typeof DecideApprovalRequestRequestSchema;
    output: typeof DecideApprovalRequestResponseSchema;
  },
  /**
   * 申請の取り下げ。申請者本人・承認待ちのみ
   *
   * @generated from rpc api_proto.v1.AdminService.CancelApprovalRequest
   */
  cancelApprovalRequest: {
    methodKind: "unary";
    input: typeof CancelApprovalRequestRequestSchema;
    output: typeof CancelApprovalRequestResponseSchema;
  },
  /**
   * 承認をバイパスした即時実行。ceo のみ。バイパスであることを記録に残す
   *
   * @generated from rpc api_proto.v1.AdminService.ExecuteApprovalRequestBypass
   */
  executeApprovalRequestBypass: {
    methodKind: "unary";
    input: typeof ExecuteApprovalRequestBypassRequestSchema;
    output: typeof ExecuteApprovalRequestBypassResponseSchema;
  },
  /**
   * 監査ログの参照（plan-restructure-2026-10 R6 tasks 6.5）
   *
   * @generated from rpc api_proto.v1.AdminService.ListAdminAuditLogs
   */
  listAdminAuditLogs: {
    methodKind: "unary";
    input: typeof ListAdminAuditLogsRequestSchema;
    output: typeof ListAdminAuditLogsResponseSchema;
  },
  /**
   * 企業ロゴ・社印設定
   *
   * @generated from rpc api_proto.v1.AdminService.UploadCompanyImage
   */
  uploadCompanyImage: {
    methodKind: "unary";
    input: typeof UploadCompanyImageRequestSchema;
    output: typeof UploadCompanyImageResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyImages
   */
  updateCompanyImages: {
    methodKind: "unary";
    input: typeof UpdateCompanyImagesRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UploadCustomerCsv
   */
  uploadCustomerCsv: {
    methodKind: "unary";
    input: typeof UploadCustomerCsvRequestSchema;
    output: typeof UploadCustomerCsvResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UploadDealCsv
   */
  uploadDealCsv: {
    methodKind: "unary";
    input: typeof UploadDealCsvRequestSchema;
    output: typeof UploadCustomerCsvResponseSchema;
  },
  /**
   * 案件一覧の列設定API
   *
   * @generated from rpc api_proto.v1.AdminService.GetDealListColumns
   */
  getDealListColumns: {
    methodKind: "unary";
    input: typeof GetDealListColumnsRequestSchema;
    output: typeof GetDealListColumnsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.SaveDealListColumns
   */
  saveDealListColumns: {
    methodKind: "unary";
    input: typeof SaveDealListColumnsRequestSchema;
    output: typeof SaveDealListColumnsResponseSchema;
  },
  /**
   * 工種を作成する
   *
   * @generated from rpc api_proto.v1.AdminService.CreateConstructionType
   */
  createConstructionType: {
    methodKind: "unary";
    input: typeof CreateConstructionTypeRequestSchema;
    output: typeof CreateConstructionTypeResponseSchema;
  },
  /**
   * 工種を更新する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateConstructionType
   */
  updateConstructionType: {
    methodKind: "unary";
    input: typeof UpdateConstructionTypeRequestSchema;
    output: typeof UpdateConstructionTypeResponseSchema;
  },
  /**
   * 工種を削除する
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteConstructionType
   */
  deleteConstructionType: {
    methodKind: "unary";
    input: typeof DeleteConstructionTypeRequestSchema;
    output: typeof DeleteConstructionTypeResponseSchema;
  },
  /**
   * 工種を一覧取得する
   *
   * @generated from rpc api_proto.v1.AdminService.GetConstructionTypeList
   */
  getConstructionTypeList: {
    methodKind: "unary";
    input: typeof GetConstructionTypeListRequestSchema;
    output: typeof GetConstructionTypeListResponseSchema;
  },
  /**
   * 工種を取得する
   *
   * @generated from rpc api_proto.v1.AdminService.GetConstructionTypeDetail
   */
  getConstructionTypeDetail: {
    methodKind: "unary";
    input: typeof GetConstructionTypeRequestSchema;
    output: typeof GetConstructionTypeResponseSchema;
  },
  /**
   * 企業工種紐付けを作成する
   *
   * @generated from rpc api_proto.v1.AdminService.CreateCompanyConstructionType
   */
  createCompanyConstructionType: {
    methodKind: "unary";
    input: typeof CreateCompanyConstructionTypeRequestSchema;
    output: typeof CreateCompanyConstructionTypeResponseSchema;
  },
  /**
   * 企業工種紐付けを更新する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateCompanyConstructionType
   */
  updateCompanyConstructionType: {
    methodKind: "unary";
    input: typeof UpdateCompanyConstructionTypeRequestSchema;
    output: typeof UpdateCompanyConstructionTypeResponseSchema;
  },
  /**
   * 企業工種紐付けを削除する
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteCompanyConstructionType
   */
  deleteCompanyConstructionType: {
    methodKind: "unary";
    input: typeof DeleteCompanyConstructionTypeRequestSchema;
    output: typeof DeleteCompanyConstructionTypeResponseSchema;
  },
  /**
   * 企業工種紐付けを一覧取得する
   *
   * @generated from rpc api_proto.v1.AdminService.GetCompanyConstructionTypeList
   */
  getCompanyConstructionTypeList: {
    methodKind: "unary";
    input: typeof GetCompanyConstructionTypeListRequestSchema;
    output: typeof GetCompanyConstructionTypeListResponseSchema;
  },
  /**
   * 企業工種紐付けを取得する
   *
   * @generated from rpc api_proto.v1.AdminService.GetCompanyConstructionTypeDetail
   */
  getCompanyConstructionTypeDetail: {
    methodKind: "unary";
    input: typeof GetCompanyConstructionTypeRequestSchema;
    output: typeof GetCompanyConstructionTypeResponseSchema;
  },
  /**
   * 色マスターのメーカー一覧取得
   *
   * @generated from rpc api_proto.v1.AdminService.ListColorManufacturers
   */
  listColorManufacturers: {
    methodKind: "unary";
    input: typeof ListColorManufacturersRequestSchema;
    output: typeof ListColorManufacturersResponseSchema;
  },
  /**
   * 色マスター検索
   *
   * @generated from rpc api_proto.v1.AdminService.ListColors
   */
  listColors: {
    methodKind: "unary";
    input: typeof ListColorsRequestSchema;
    output: typeof ListColorsResponseSchema;
  },
  /**
   * 色マスターを作成する
   *
   * @generated from rpc api_proto.v1.AdminService.CreateColor
   */
  createColor: {
    methodKind: "unary";
    input: typeof CreateColorRequestSchema;
    output: typeof CreateColorResponseSchema;
  },
  /**
   * 色マスターを更新する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateColor
   */
  updateColor: {
    methodKind: "unary";
    input: typeof UpdateColorRequestSchema;
    output: typeof UpdateColorResponseSchema;
  },
  /**
   * 色マスターを削除する
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteColor
   */
  deleteColor: {
    methodKind: "unary";
    input: typeof DeleteColorRequestSchema;
    output: typeof DeleteColorResponseSchema;
  },
  /**
   * 色マスターCSV一括インポート
   *
   * @generated from rpc api_proto.v1.AdminService.UploadColorCsv
   */
  uploadColorCsv: {
    methodKind: "unary";
    input: typeof UploadColorCsvRequestSchema;
    output: typeof UploadColorCsvResponseSchema;
  },
  /**
   * プロジェクトID(ULID)を指定してAIカラープロジェクトのサマリーを取得する。
   *
   * @generated from rpc api_proto.v1.AdminService.GetAiColorProjectSummary
   */
  getAiColorProjectSummary: {
    methodKind: "unary";
    input: typeof GetAiColorProjectSummaryRequestSchema;
    output: typeof GetAiColorProjectSummaryResponseSchema;
  },
  /**
   * プロジェクトID(ULID)を指定してAIカラープロジェクト（プロジェクト・画像・共有リンク）を論理削除する。
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteAiColorProject
   */
  deleteAiColorProject: {
    methodKind: "unary";
    input: typeof DeleteAiColorProjectRequestSchema;
    output: typeof DeleteAiColorProjectResponseSchema;
  },
  /**
   * AIカラー素材マスターのxlsx一括UPSERT (Issue #1809)
   *
   * @generated from rpc api_proto.v1.AdminService.UploadMaterialXlsx
   */
  uploadMaterialXlsx: {
    methodKind: "unary";
    input: typeof UploadMaterialXlsxRequestSchema;
    output: typeof UploadMaterialXlsxResponseSchema;
  },
  /**
   * AIカラー素材マスター: メーカー一覧（フィルタUI用、distinct）
   *
   * @generated from rpc api_proto.v1.AdminService.ListMaterialManufacturers
   */
  listMaterialManufacturers: {
    methodKind: "unary";
    input: typeof ListMaterialManufacturersRequestSchema;
    output: typeof ListMaterialManufacturersResponseSchema;
  },
  /**
   * AIカラー素材マスター: 検索（メーカー絞込・フリーワード・ページネーション）
   *
   * @generated from rpc api_proto.v1.AdminService.ListMaterials
   */
  listMaterials: {
    methodKind: "unary";
    input: typeof ListMaterialsRequestSchema;
    output: typeof ListMaterialsResponseSchema;
  },
  /**
   * AIカラー素材マスター: 単体追加
   *
   * @generated from rpc api_proto.v1.AdminService.CreateMaterial
   */
  createMaterial: {
    methodKind: "unary";
    input: typeof CreateMaterialRequestSchema;
    output: typeof CreateMaterialResponseSchema;
  },
  /**
   * AIカラー素材マスター: 単体更新
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMaterial
   */
  updateMaterial: {
    methodKind: "unary";
    input: typeof UpdateMaterialRequestSchema;
    output: typeof UpdateMaterialResponseSchema;
  },
  /**
   * AIカラー素材マスター: 単体削除（論理削除）
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteMaterial
   */
  deleteMaterial: {
    methodKind: "unary";
    input: typeof DeleteMaterialRequestSchema;
    output: typeof DeleteMaterialResponseSchema;
  },
  /**
   * やねプロ メディアサイト CMS
   * 記事一覧（NO_SIDE_EFFECTS）
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaArticles
   */
  listMediaArticles: {
    methodKind: "unary";
    input: typeof ListMediaArticlesRequestSchema;
    output: typeof ListMediaArticlesResponseSchema;
  },
  /**
   * 記事詳細取得（公開 revision + draft revision 両方）（NO_SIDE_EFFECTS）
   *
   * @generated from rpc api_proto.v1.AdminService.GetMediaArticle
   */
  getMediaArticle: {
    methodKind: "unary";
    input: typeof GetMediaArticleRequestSchema;
    output: typeof GetMediaArticleResponseSchema;
  },
  /**
   * 下書き保存（slug 未存在なら新規作成）
   *
   * @generated from rpc api_proto.v1.AdminService.SaveMediaArticleDraft
   */
  saveMediaArticleDraft: {
    methodKind: "unary";
    input: typeof SaveMediaArticleDraftRequestSchema;
    output: typeof SaveMediaArticleDraftResponseSchema;
  },
  /**
   * 即時公開（content 未指定なら現 draft を昇格）
   *
   * @generated from rpc api_proto.v1.AdminService.PublishMediaArticle
   */
  publishMediaArticle: {
    methodKind: "unary";
    input: typeof PublishMediaArticleRequestSchema;
    output: typeof PublishMediaArticleResponseSchema;
  },
  /**
   * 記事削除（全リビジョン・プレビュートークン・タグ紐付け・掲載枠をカスケード削除するハード削除）
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaArticle
   */
  deleteMediaArticle: {
    methodKind: "unary";
    input: typeof DeleteMediaArticleRequestSchema;
    output: typeof DeleteMediaArticleResponseSchema;
  },
  /**
   * プレビュートークン発行（期限 3 日）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateMediaPreviewToken
   */
  createMediaPreviewToken: {
    methodKind: "unary";
    input: typeof CreateMediaPreviewTokenRequestSchema;
    output: typeof CreateMediaPreviewTokenResponseSchema;
  },
  /**
   * メディアサイト: カテゴリ管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaCategories
   */
  listMediaCategories: {
    methodKind: "unary";
    input: typeof ListMediaCategoriesRequestSchema;
    output: typeof ListMediaCategoriesResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaCategory
   */
  upsertMediaCategory: {
    methodKind: "unary";
    input: typeof UpsertMediaCategoryRequestSchema;
    output: typeof UpsertMediaCategoryResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaCategory
   */
  deleteMediaCategory: {
    methodKind: "unary";
    input: typeof DeleteMediaCategoryRequestSchema;
    output: typeof DeleteMediaCategoryResponseSchema;
  },
  /**
   * メディアサイト: タグ管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaTags
   */
  listMediaTags: {
    methodKind: "unary";
    input: typeof ListMediaTagsRequestSchema;
    output: typeof ListMediaTagsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaTag
   */
  upsertMediaTag: {
    methodKind: "unary";
    input: typeof UpsertMediaTagRequestSchema;
    output: typeof UpsertMediaTagResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaTag
   */
  deleteMediaTag: {
    methodKind: "unary";
    input: typeof DeleteMediaTagRequestSchema;
    output: typeof DeleteMediaTagResponseSchema;
  },
  /**
   * メディアサイト: 著者管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaAuthors
   */
  listMediaAuthors: {
    methodKind: "unary";
    input: typeof ListMediaAuthorsRequestSchema;
    output: typeof ListMediaAuthorsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.GetMediaAuthor
   */
  getMediaAuthor: {
    methodKind: "unary";
    input: typeof GetMediaAuthorRequestSchema;
    output: typeof GetMediaAuthorResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaAuthor
   */
  upsertMediaAuthor: {
    methodKind: "unary";
    input: typeof UpsertMediaAuthorRequestSchema;
    output: typeof UpsertMediaAuthorResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaAuthor
   */
  deleteMediaAuthor: {
    methodKind: "unary";
    input: typeof DeleteMediaAuthorRequestSchema;
    output: typeof DeleteMediaAuthorResponseSchema;
  },
  /**
   * メディアサイト: インタビュー管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaInterviews
   */
  listMediaInterviews: {
    methodKind: "unary";
    input: typeof ListMediaInterviewsRequestSchema;
    output: typeof ListMediaInterviewsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.GetMediaInterview
   */
  getMediaInterview: {
    methodKind: "unary";
    input: typeof GetMediaInterviewRequestSchema;
    output: typeof GetMediaInterviewResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaInterview
   */
  upsertMediaInterview: {
    methodKind: "unary";
    input: typeof UpsertMediaInterviewRequestSchema;
    output: typeof UpsertMediaInterviewResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaInterview
   */
  deleteMediaInterview: {
    methodKind: "unary";
    input: typeof DeleteMediaInterviewRequestSchema;
    output: typeof DeleteMediaInterviewResponseSchema;
  },
  /**
   * メディアサイト: 認定店管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaRoofers
   */
  listMediaRoofers: {
    methodKind: "unary";
    input: typeof ListMediaRoofersRequestSchema;
    output: typeof ListMediaRoofersResponseSchema;
  },
  /**
   * 認定店1件の取得（NO_SIDE_EFFECTS）
   *
   * @generated from rpc api_proto.v1.AdminService.GetMediaRoofer
   */
  getMediaRoofer: {
    methodKind: "unary";
    input: typeof GetMediaRooferRequestSchema;
    output: typeof GetMediaRooferResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaRoofer
   */
  upsertMediaRoofer: {
    methodKind: "unary";
    input: typeof UpsertMediaRooferRequestSchema;
    output: typeof UpsertMediaRooferResponseSchema;
  },
  /**
   * 認定店の列単位の部分更新（update_maskに列挙したスカラー列だけを単文UPDATE。子配列・レスポンス専用列はInvalidArgument）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferFields
   */
  updateMediaRooferFields: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferFieldsRequestSchema;
    output: typeof UpdateMediaRooferFieldsResponseSchema;
  },
  /**
   * 認定店の列を指定した新規作成（AI経由の入稿用。作成した店は非掲載・非公開で始まる）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateMediaRooferFields
   */
  createMediaRooferFields: {
    methodKind: "unary";
    input: typeof CreateMediaRooferFieldsRequestSchema;
    output: typeof CreateMediaRooferFieldsResponseSchema;
  },
  /**
   * 認定店の子配列（対応エリア・職人・施工事例・資格）を配列ごとに置換する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferChildren
   */
  updateMediaRooferChildren: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferChildrenRequestSchema;
    output: typeof UpdateMediaRooferChildrenResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaRoofer
   */
  deleteMediaRoofer: {
    methodKind: "unary";
    input: typeof DeleteMediaRooferRequestSchema;
    output: typeof DeleteMediaRooferResponseSchema;
  },
  /**
   * 認定店個別ページの公開状態切り替え（upsert とは分離した専用 RPC）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferPublished
   */
  updateMediaRooferPublished: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferPublishedRequestSchema;
    output: typeof UpdateMediaRooferPublishedResponseSchema;
  },
  /**
   * 認定店の掲載状態の切り替え（公開サイトに出すかどうか。upsert とは分離した専用 RPC）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferListed
   */
  updateMediaRooferListed: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferListedRequestSchema;
    output: typeof UpdateMediaRooferListedResponseSchema;
  },
  /**
   * メディアサイト: 資格・受賞歴・加盟団体マスター管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaCredentialItems
   */
  listMediaCredentialItems: {
    methodKind: "unary";
    input: typeof ListMediaCredentialItemsRequestSchema;
    output: typeof ListMediaCredentialItemsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.UpsertMediaCredentialItem
   */
  upsertMediaCredentialItem: {
    methodKind: "unary";
    input: typeof UpsertMediaCredentialItemRequestSchema;
    output: typeof UpsertMediaCredentialItemResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaCredentialItem
   */
  deleteMediaCredentialItem: {
    methodKind: "unary";
    input: typeof DeleteMediaCredentialItemRequestSchema;
    output: typeof DeleteMediaCredentialItemResponseSchema;
  },
  /**
   * メディアサイト: Places API から認定店の口コミを取得・キャッシュ
   *
   * @generated from rpc api_proto.v1.AdminService.FetchMediaRooferReviews
   */
  fetchMediaRooferReviews: {
    methodKind: "unary";
    input: typeof FetchMediaRooferReviewsRequestSchema;
    output: typeof FetchMediaRooferReviewsResponseSchema;
  },
  /**
   * メディアサイト: 認定店の Google 口コミの掲載をやめる（Place ID・評価スナップショット・代表口コミ・口コミキャッシュを消す専用 RPC）
   *
   * @generated from rpc api_proto.v1.AdminService.ClearMediaRooferReviews
   */
  clearMediaRooferReviews: {
    methodKind: "unary";
    input: typeof ClearMediaRooferReviewsRequestSchema;
    output: typeof ClearMediaRooferReviewsResponseSchema;
  },
  /**
   * メディアサイト: いえサプリ案件データから認定店の活用データを計算して D1 に保存（iesapuri_company_id 未設定時は MEDIA_ROOFER_COMPANY_LINK_REQUIRED）
   *
   * @generated from rpc api_proto.v1.AdminService.FetchMediaRooferUsageMetrics
   */
  fetchMediaRooferUsageMetrics: {
    methodKind: "unary";
    input: typeof FetchMediaRooferUsageMetricsRequestSchema;
    output: typeof FetchMediaRooferUsageMetricsResponseSchema;
  },
  /**
   * メディアサイト: 活用データセクションの公開ページ表示フラグのみを切り替える専用 RPC（upsert とは分離）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferUsageMetricsVisibility
   */
  updateMediaRooferUsageMetricsVisibility: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferUsageMetricsVisibilityRequestSchema;
    output: typeof UpdateMediaRooferUsageMetricsVisibilityResponseSchema;
  },
  /**
   * メディアサイト: AI活用度メーター（一覧カード・個別ページ）の表示フラグのみを切り替える専用 RPC（upsert とは分離）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaRooferAiUsageVisibility
   */
  updateMediaRooferAiUsageVisibility: {
    methodKind: "unary";
    input: typeof UpdateMediaRooferAiUsageVisibilityRequestSchema;
    output: typeof UpdateMediaRooferAiUsageVisibilityResponseSchema;
  },
  /**
   * メディアサイト: URL 先ページの OGP メタデータ取得（施工事例カードの入力省力化）
   *
   * @generated from rpc api_proto.v1.AdminService.FetchMediaUrlMetadata
   */
  fetchMediaUrlMetadata: {
    methodKind: "unary";
    input: typeof FetchMediaUrlMetadataRequestSchema;
    output: typeof FetchMediaUrlMetadataResponseSchema;
  },
  /**
   * メディアサイト: 掲載枠（トップ各セクション・人気・PICK UP）管理
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaFeaturedItems
   */
  listMediaFeaturedItems: {
    methodKind: "unary";
    input: typeof ListMediaFeaturedItemsRequestSchema;
    output: typeof ListMediaFeaturedItemsResponseSchema;
  },
  /**
   * @generated from rpc api_proto.v1.AdminService.SetMediaFeaturedItems
   */
  setMediaFeaturedItems: {
    methodKind: "unary";
    input: typeof SetMediaFeaturedItemsRequestSchema;
    output: typeof SetMediaFeaturedItemsResponseSchema;
  },
  /**
   * メディアサイト: 画像アップロード（公開 R2 の media ディレクトリ）
   *
   * @generated from rpc api_proto.v1.AdminService.UploadMediaImage
   */
  uploadMediaImage: {
    methodKind: "unary";
    input: typeof UploadMediaImageRequestSchema;
    output: typeof UploadMediaImageResponseSchema;
  },
  /**
   * メディアサイト: 画像キャビネット（URL 台帳）の一覧取得（ページング + 画像名部分一致）
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaImages
   */
  listMediaImages: {
    methodKind: "unary";
    input: typeof ListMediaImagesRequestSchema;
    output: typeof ListMediaImagesResponseSchema;
  },
  /**
   * メディアサイト: 外部URLから画像を取り込んで台帳へ登録（httpsのみ・SSRFガード・10MB上限・image/* のみ）
   *
   * @generated from rpc api_proto.v1.AdminService.ImportMediaImageFromUrl
   */
  importMediaImageFromUrl: {
    methodKind: "unary";
    input: typeof ImportMediaImageFromUrlRequestSchema;
    output: typeof ImportMediaImageFromUrlResponseSchema;
  },
  /**
   * メディアサイト: 画像アップロード用の署名付きPUT URL発行（ステージングキー・有効期限10分）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateMediaImageUpload
   */
  createMediaImageUpload: {
    methodKind: "unary";
    input: typeof CreateMediaImageUploadRequestSchema;
    output: typeof CreateMediaImageUploadResponseSchema;
  },
  /**
   * メディアサイト: ステージングへのPUT完了後に読み戻して変換・台帳登録し、ステージングを削除
   *
   * @generated from rpc api_proto.v1.AdminService.FinalizeMediaImageUpload
   */
  finalizeMediaImageUpload: {
    methodKind: "unary";
    input: typeof FinalizeMediaImageUploadRequestSchema;
    output: typeof FinalizeMediaImageUploadResponseSchema;
  },
  /**
   * メディアサイト: 画像キャビネット1件の取得（使用箇所の逆引き込み）（NO_SIDE_EFFECTS）
   *
   * @generated from rpc api_proto.v1.AdminService.GetMediaImage
   */
  getMediaImage: {
    methodKind: "unary";
    input: typeof GetMediaImageRequestSchema;
    output: typeof GetMediaImageResponseSchema;
  },
  /**
   * メディアサイト: 画像キャビネットの画像名更新
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaImageName
   */
  updateMediaImageName: {
    methodKind: "unary";
    input: typeof UpdateMediaImageNameRequestSchema;
    output: typeof UpdateMediaImageNameResponseSchema;
  },
  /**
   * メディアサイト: 画像キャビネットの台帳レコード削除（R2 実ファイルは消さない）
   *
   * @generated from rpc api_proto.v1.AdminService.DeleteMediaImage
   */
  deleteMediaImage: {
    methodKind: "unary";
    input: typeof DeleteMediaImageRequestSchema;
    output: typeof DeleteMediaImageResponseSchema;
  },
  /**
   * メディアサイト: お問い合わせ一覧取得（認定店・対応状況でフィルタ可）
   *
   * @generated from rpc api_proto.v1.AdminService.ListMediaContactSubmissions
   */
  listMediaContactSubmissions: {
    methodKind: "unary";
    input: typeof ListMediaContactSubmissionsRequestSchema;
    output: typeof ListMediaContactSubmissionsResponseSchema;
  },
  /**
   * メディアサイト: お問い合わせの対応状況を更新する
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateMediaContactSubmissionHandled
   */
  updateMediaContactSubmissionHandled: {
    methodKind: "unary";
    input: typeof UpdateMediaContactSubmissionHandledRequestSchema;
    output: typeof UpdateMediaContactSubmissionHandledResponseSchema;
  },
  /**
   * 監修ダッシュボード（残量マトリクス）
   *
   * @generated from rpc api_proto.v1.AdminService.GetKnowledgeReviewDashboard
   */
  getKnowledgeReviewDashboard: {
    methodKind: "unary";
    input: typeof GetKnowledgeReviewDashboardRequestSchema;
    output: typeof GetKnowledgeReviewDashboardResponseSchema;
  },
  /**
   * 要監修フラグ一覧（フィルタ・ページング・グループ集計モード）
   *
   * @generated from rpc api_proto.v1.AdminService.ListKnowledgeReviewFlags
   */
  listKnowledgeReviewFlags: {
    methodKind: "unary";
    input: typeof ListKnowledgeReviewFlagsRequestSchema;
    output: typeof ListKnowledgeReviewFlagsResponseSchema;
  },
  /**
   * フラグ単体の判断（承認/棄却）
   *
   * @generated from rpc api_proto.v1.AdminService.ResolveKnowledgeReviewFlag
   */
  resolveKnowledgeReviewFlag: {
    methodKind: "unary";
    input: typeof ResolveKnowledgeReviewFlagRequestSchema;
    output: typeof ResolveKnowledgeReviewFlagResponseSchema;
  },
  /**
   * フラグのメモのみ更新（判断前でも保存できる。判断時はメモが判断の記録を兼ねる）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateKnowledgeReviewFlagNote
   */
  updateKnowledgeReviewFlagNote: {
    methodKind: "unary";
    input: typeof UpdateKnowledgeReviewFlagNoteRequestSchema;
    output: typeof UpdateKnowledgeReviewFlagNoteResponseSchema;
  },
  /**
   * フラグの一括判断（ids または group_key）
   *
   * @generated from rpc api_proto.v1.AdminService.BulkResolveKnowledgeReviewFlags
   */
  bulkResolveKnowledgeReviewFlags: {
    methodKind: "unary";
    input: typeof BulkResolveKnowledgeReviewFlagsRequestSchema;
    output: typeof BulkResolveKnowledgeReviewFlagsResponseSchema;
  },
  /**
   * フラグの一括起票（AI 再監修等。引用の本文一致検証・重複スキップ・件数上限あり）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateKnowledgeReviewFlags
   */
  createKnowledgeReviewFlags: {
    methodKind: "unary";
    input: typeof CreateKnowledgeReviewFlagsRequestSchema;
    output: typeof CreateKnowledgeReviewFlagsResponseSchema;
  },
  /**
   * 再監修対象の節の抽出（棚卸し期限・成熟度・未解決フラグで絞り込み）
   *
   * @generated from rpc api_proto.v1.AdminService.ListKnowledgeSectionsForReview
   */
  listKnowledgeSectionsForReview: {
    methodKind: "unary";
    input: typeof ListKnowledgeSectionsForReviewRequestSchema;
    output: typeof ListKnowledgeSectionsForReviewResponseSchema;
  },
  /**
   * 知識文書の一覧
   *
   * @generated from rpc api_proto.v1.AdminService.ListKnowledgeDocuments
   */
  listKnowledgeDocuments: {
    methodKind: "unary";
    input: typeof ListKnowledgeDocumentsRequestSchema;
    output: typeof ListKnowledgeDocumentsResponseSchema;
  },
  /**
   * 文書の詳細（節ツリー付き）
   *
   * @generated from rpc api_proto.v1.AdminService.GetKnowledgeDocument
   */
  getKnowledgeDocument: {
    methodKind: "unary";
    input: typeof GetKnowledgeDocumentRequestSchema;
    output: typeof GetKnowledgeDocumentResponseSchema;
  },
  /**
   * 文書の新規作成（節は作らない。前文概念は廃止）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateKnowledgeDocument
   */
  createKnowledgeDocument: {
    methodKind: "unary";
    input: typeof CreateKnowledgeDocumentRequestSchema;
    output: typeof CreateKnowledgeDocumentResponseSchema;
  },
  /**
   * 文書メタ（タイトル・前提/免責）の更新
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateKnowledgeDocument
   */
  updateKnowledgeDocument: {
    methodKind: "unary";
    input: typeof UpdateKnowledgeDocumentRequestSchema;
    output: typeof UpdateKnowledgeDocumentResponseSchema;
  },
  /**
   * 節の取得（open フラグ付き）
   *
   * @generated from rpc api_proto.v1.AdminService.GetKnowledgeSection
   */
  getKnowledgeSection: {
    methodKind: "unary";
    input: typeof GetKnowledgeSectionRequestSchema;
    output: typeof GetKnowledgeSectionResponseSchema;
  },
  /**
   * 節の追加（章末尾に自動採番・テンプレ雛形挿入）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateKnowledgeSection
   */
  createKnowledgeSection: {
    methodKind: "unary";
    input: typeof CreateKnowledgeSectionRequestSchema;
    output: typeof CreateKnowledgeSectionResponseSchema;
  },
  /**
   * 章の追加（文書末尾に自動採番・章見出し節を作成）
   *
   * @generated from rpc api_proto.v1.AdminService.CreateKnowledgeChapter
   */
  createKnowledgeChapter: {
    methodKind: "unary";
    input: typeof CreateKnowledgeChapterRequestSchema;
    output: typeof CreateKnowledgeChapterResponseSchema;
  },
  /**
   * 節の更新（楽観ロック・revision 発行・origin_flag 連動）
   *
   * @generated from rpc api_proto.v1.AdminService.UpdateKnowledgeSection
   */
  updateKnowledgeSection: {
    methodKind: "unary";
    input: typeof UpdateKnowledgeSectionRequestSchema;
    output: typeof UpdateKnowledgeSectionResponseSchema;
  },
  /**
   * 節の論理削除（物理削除は存在しない）
   *
   * @generated from rpc api_proto.v1.AdminService.SupersedeKnowledgeSection
   */
  supersedeKnowledgeSection: {
    methodKind: "unary";
    input: typeof SupersedeKnowledgeSectionRequestSchema;
    output: typeof SupersedeKnowledgeSectionResponseSchema;
  },
  /**
   * 節の版履歴
   *
   * @generated from rpc api_proto.v1.AdminService.ListKnowledgeSectionRevisions
   */
  listKnowledgeSectionRevisions: {
    methodKind: "unary";
    input: typeof ListKnowledgeSectionRevisionsRequestSchema;
    output: typeof ListKnowledgeSectionRevisionsResponseSchema;
  },
  /**
   * 指定版の内容で新 revision を発行（履歴は保持）
   *
   * @generated from rpc api_proto.v1.AdminService.RevertKnowledgeSection
   */
  revertKnowledgeSection: {
    methodKind: "unary";
    input: typeof RevertKnowledgeSectionRequestSchema;
    output: typeof RevertKnowledgeSectionResponseSchema;
  },
  /**
   * 章・節の並び替え（節の章間移動を含む文書単位の全置換）。
   * chapter_no / seq / breadcrumb だけを更新し、section_key と本文は書き換えない（版も発行しない）
   *
   * @generated from rpc api_proto.v1.AdminService.ReorderKnowledgeSections
   */
  reorderKnowledgeSections: {
    methodKind: "unary";
    input: typeof ReorderKnowledgeSectionsRequestSchema;
    output: typeof ReorderKnowledgeSectionsResponseSchema;
  },
  /**
   * 検索プレビュー（ngram 全文検索）
   *
   * @generated from rpc api_proto.v1.AdminService.SearchKnowledgePreview
   */
  searchKnowledgePreview: {
    methodKind: "unary";
    input: typeof SearchKnowledgePreviewRequestSchema;
    output: typeof SearchKnowledgePreviewResponseSchema;
  },
  /**
   * 正本 markdown のエクスポート
   *
   * @generated from rpc api_proto.v1.AdminService.ExportKnowledgeMarkdown
   */
  exportKnowledgeMarkdown: {
    methodKind: "unary";
    input: typeof ExportKnowledgeMarkdownRequestSchema;
    output: typeof ExportKnowledgeMarkdownResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_proto_v1_admin_service, 0);

